import {Avatar} from 'antd'
import {organizationModel} from 'apis/model'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {IoHome, IoLinkOutline,} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import {gPaths} from 'views/AppLocals/configs'
import {getLocationLines, renderIf} from 'views/Shared'
import {SubDomainContext} from 'views/SubDomain/SubDomainContext'
import {BiShieldQuarter, BiSolidChurch} from "react-icons/bi";
import {MdLocationPin} from "react-icons/md";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {FaEarthAsia, FaLock} from "react-icons/fa6";
import {useAppConfig} from "../../../../modules/local/AppConfigContext";

const ActionButtons = ({item}) => {
    const {isLg} = useContext(LayoutContext)
    if (!isLg) return null
    return (
        <div className="flex flex-row space-x-1">
            <SubDomainContext.Consumer>
                {({isSubDomain}) => (
                    <Link
                        to={
                            isSubDomain
                                ? gPaths.organization_domain
                                : organizationModel.getLinkToDetail(item)
                        }
                        className="w-8 h-8 rounded-xl flex flex-center background-100 hover:bg-secondary-50 text-color-500 hover:text-secondary-600">
                        <IoHome size={16} className="Icon"/>
                    </Link>
                )}
            </SubDomainContext.Consumer>
        </div>
    )
}

const HeaderGroupItems = ({item}) => {
    const t = useTranslate()
    return (
        <div className="flex flex-col text-xs md:text-sm italic">
            {!!_.get(item, 'locations[0]') && (
                <div className="flex items-center">
                    <MdLocationPin size={12} className="text-color-500 mr-1"/>
                    <span className="text-color-300">{getLocationLines(item)}</span>
                </div>
            )}
            {renderIf(
                _.some([item?.parish_name, item?.diocese_name]),
                <DoubleValueItem
                    showIcon={true}
                    labelFirst="belong to parish"
                    valueFirst={item?.parish_name}
                    labelSecond={item?.diocese_name && " - " || ''}
                    valueSecond={item?.diocese?.fullname}
                    className="text-xs md:text-sm italic"
                />
            )}
            {Number(item.certified) > 0 && (
                <div className="flex items-center">
                    <BiShieldQuarter className="text-primary mr-2"/>
                    <span className="text-color-300">
                        <b className="font-bold text-color-100">{`${t('verified')} `}</b>
                        {t('provider')}
                    </span>
                </div>
            )}
        </div>
    )
}

const SubDomainHeader = ({item}) => {
    if (!Boolean(item.sub_domain)) return null
    return (
        <SubDomainContext.Consumer>
            {({isSubDomain}) =>
                Boolean(item.sub_domain) && (
                    <a
                        href={[
                            window.location.protocol,
                            '//',
                            !!isSubDomain ? '' : item.sub_domain + '.',
                            window.location.host,
                        ].join('')}
                        className="flex items-center gap-2 text-primary">
                        <IoLinkOutline/>
                        <span className="text-xs md:text-sm italic">
              {[
                  !!isSubDomain ? '' : item.sub_domain + '.',
                  window.location.host,
              ].join('')}
            </span>
                    </a>
                )
            }
        </SubDomainContext.Consumer>
    )
}

const OrganizationSettingHeader = ({organization}) => {
    const t = useTranslate()

    const {isSm} = useContext(LayoutContext)
    const {org_types = {}} = useAppConfig('org_types')
    const org_type = _.get(org_types, _.get(organization, 'org_type') || '900')

    const item = organization || {}

    const avatar = organizationModel.getFullAvatarUrl(item)

    if (_.isEmpty(item)) return null

    return (
        <div className="py-3 w-full container mx-auto">
            <div className="flex items-center gap-3">
                <Avatar
                    size={isSm ? 65 : 80}
                    icon={<BiSolidChurch size={isSm ? 45 : 60} className="text-color-400"/>}
                    src={avatar}
                    className="flex flex-center background-100 rounded-xl object-cover"
                />
                <div className="flex flex-col flex-1 gap-1.5">
                    <Link
                        className="text-base md:text-xl text-color-000 font-bold no-underline"
                        title={item.title}
                        to={organizationModel.getLinkToDetail(item)}>
                        {item.title}
                    </Link>
                    <div className="flex items-center flex-1 gap-x-4">
                        {(
                            <span className="flex items-center gap-1 flex-shrink-0 font-semibold text-blue-600 tracking-wider">
                                {t(org_type || 'group')}
                            </span>
                        )}
                        {item?.privacy === 1 ? (
                            <span className="flex items-center gap-1 text-gray-700">
                                <FaEarthAsia size={12}/>
                                <span className="font-medium">
                                    {t('public')}
                                </span>
                            </span>
                        ) : (
                            <span className="flex items-center gap-1 text-gray-700">
                                <FaLock size={12}/>
                                <span className="font-medium">
                                    {t('public')}
                                </span>
                            </span>
                        )}
                    </div>
                    {/*<SubDomainHeader {...{item}} />*/}
                    {/*<HeaderGroupItems {...{item}} />*/}
                </div>
                <ActionButtons {...{item}} />
            </div>
        </div>
    )
}

export default OrganizationSettingHeader
